<template>
  <!-- Landing Layout - Mobile-friendly -->
  <div class="w-full flex flex-col">
    <!-- Main content area with mobile-friendly spacing -->
    <main
      id="main"
      tabindex="-1"
      class="flex-1 flex flex-col w-full items-center pt-6"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
// Navigation is now handled at the App.vue level
// Landing pages typically don't show navigation anyway
</script>

<style scoped>
/* Mobile-specific adjustments */
@media (max-width: 768px) {
  #main {
    padding-top: 2rem;
  }
}
</style>
